import { render, staticRenderFns } from "./zaikupandianMain.vue?vue&type=template&id=10993a74&scoped=true&"
import script from "./zaikupandianMain.vue?vue&type=script&lang=js&"
export * from "./zaikupandianMain.vue?vue&type=script&lang=js&"
import style0 from "./zaikupandianMain.vue?vue&type=style&index=0&id=10993a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10993a74",
  null
  
)

export default component.exports